// LOAD-BEARING SIDE-EFFECT IMPORT — do not delete as "unused".
// The hub import warmed the Rematch model cluster; this specifier restores
// that init order. It retires with the Z2 codemod.
import '@/pages/api/scribeAPIV2';

import { isEvidenceApiAvailable } from '@/utils/backendSurfaces';
import { useQueryEvidenceIntegrations as useQueryEvidenceIntegrationsCore } from '@heidi/evidence/data';

/**
 * Fetches available evidence integration partners.
 *
 * The backend resolves the user's region from the auth token and returns
 * all partners with `is_available` based on region + server configuration.
 *
 * `GET /v2/evidence/integrations` is part of ml-scribe's cloud-only evidence
 * aggregate, so the gate carries the surface term: the chat composer mounts
 * this read on every render of the source control, and on an on-prem build the
 * route does not exist. Disabled, `data` stays `undefined` and every consumer
 * already reads that as "no partners".
 */
export function useQueryEvidenceIntegrations() {
  return useQueryEvidenceIntegrationsCore({ enabled: isEvidenceApiAvailable });
}
